import { z } from 'zod'

import { CAATypes } from './CAATypes'

export const CAACountByCAAType = z.object({
  typeCAA: CAATypes,
  amount: z.number()
})
export type CAACountByCAAType = z.infer<typeof CAACountByCAAType>
